import { Controller } from "@hotwired/stimulus"

// Gives a submit button immediate feedback: on submit it disables the button —
// guarding against a double-click — and swaps its label for a spinner plus a
// "loading…" message, so the wait never looks like a dead click. The form still
// submits (natively, or via Turbo); this only decorates it.
//
// Two completion modes:
//   - Redirecting submit (e.g. the OneLogin sign-in button, data-turbo=false): the page
//     navigates away, so the button is never restored — turbo:submit-end never fires.
//   - Turbo submit (turbo-stream / frame response): the button persists, so it is
//     restored on turbo:submit-end. Otherwise it would spin forever.
export default class extends Controller {
  static targets = ["button"]
  static values = { label: String }

  connect() {
    this.reset = this.reset.bind(this)
    this.element.addEventListener("turbo:submit-end", this.reset)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.reset)
  }

  submit() {
    const button = this.buttonTarget
    if (button.dataset.loading) return
    this.originalHtml = button.innerHTML
    button.dataset.loading = "true"
    button.disabled = true
    button.classList.add("cursor-wait", "opacity-70")
    button.innerHTML =
      '<span class="inline-flex items-center gap-2">' +
      '<svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>' +
      '<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 0 1 8-8V0C5.4 0 0 5.4 0 12h4z"></path>' +
      "</svg>" +
      `<span>${this.labelValue}</span>` +
      "</span>"
  }

  reset() {
    const button = this.buttonTarget
    if (!button.dataset.loading) return
    delete button.dataset.loading
    button.disabled = false
    button.classList.remove("cursor-wait", "opacity-70")
    if (this.originalHtml !== undefined) button.innerHTML = this.originalHtml
  }
}
